query communicationList($homeNumberId: ID!, $tz: String, $afterDatetime: String, $beforeDatetime: String, $teacherPhoneNumberId: ID) {
  communicationList(homeNumberId: $homeNumberId, beforeDatetime: $beforeDatetime, afterDatetime: $afterDatetime, teacherPhoneNumberId: $teacherPhoneNumberId) {
    count
    remaining
    list {
      ...on Message {
        __typename
        id
        insertedAt(tz: $tz)
        direction
        canEdit
        involvesCurrentUser
        conversation {
          id
          homeNumber {
            id
            label
            formattedNumber
          }
          teacherPhoneNumber {
            id
            formattedNumber
            displayName
          }
        }
        bodies {
          id
          text
          isCanon
          isOriginal
          homeLanguage {
            id
            name
            language
          }
        }
        messageFiles {
          id
          url
          height
          width
        }
        moods {
          id
          name
        }
        status
      }

      ...on PhoneCall {
        __typename
        id
        insertedAt(tz: $tz)
        direction
        canEdit
        involvesCurrentUser
        conversation {
          id
          homeNumber {
            id
            label
            formattedNumber
          }
          teacherPhoneNumber {
            id
            formattedNumber
            displayName
          }
        }
        notes
        status
      }
    }
  }
}
